"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketingCard = MarketingCardComponent;
Object.defineProperty(exports, "StyledMarketingCard", {
  enumerable: true,
  get: function get() {
    return _styledMarketingCard.StyledMarketingCard;
  }
});
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledMarketingCard = require("./styled-marketing-card");
var _excluded = ["bodySlot", "buttonSlot", "children", "dataTestId", "header", "icon", "isBrandIcon", "linkText", "linkUrl", "newWindow", "onClick", "paragraphText", "representativeText", "subHeader"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var propTypes = {
  borderColour: _propTypes["default"].oneOf(['brandMid', undefined, null]),
  bodySlot: _propTypes["default"].node,
  buttonSlot: _propTypes["default"].node,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  dataTestId: _propTypes["default"].string,
  header: _propTypes["default"].element,
  icon: _propTypes["default"].element,
  isBrandIcon: _propTypes["default"].bool,
  linkText: _propTypes["default"].string,
  linkUrl: _propTypes["default"].string,
  newWindow: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  paragraphText: _propTypes["default"].string,
  representativeText: _propTypes["default"].string,
  subHeader: _propTypes["default"].string
};
var defaultProps = {
  bodySlot: null,
  borderColour: null,
  buttonSlot: null,
  children: null,
  dataTestId: null,
  header: null,
  icon: null,
  isBrandIcon: false,
  linkText: null,
  linkUrl: null,
  newWindow: false,
  onClick: null,
  paragraphText: null,
  representativeText: null,
  subHeader: null
};
function MarketingCardComponent(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var bodySlot = props.bodySlot,
    buttonSlot = props.buttonSlot,
    children = props.children,
    dataTestId = props.dataTestId,
    header = props.header,
    icon = props.icon,
    isBrandIcon = props.isBrandIcon,
    linkText = props.linkText,
    linkUrl = props.linkUrl,
    newWindow = props.newWindow,
    onClick = props.onClick,
    paragraphText = props.paragraphText,
    representativeText = props.representativeText,
    subHeader = props.subHeader,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledMarketingCard, _extends({
    "data-testid": dataTestId || 'fuse-marketing-card'
  }, others), children || /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledContent, null, /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledHeader, {
    hasIcon: !!icon
  }, header, icon && /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledCardIcon, {
    icon: icon,
    isBrandIcon: isBrandIcon
  })), subHeader && /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledSubHeader, {
    type: "heading",
    size: {
      xxs: '1',
      m: '1',
      l: '2'
    },
    tag: "h3"
  }, subHeader), bodySlot || paragraphText && /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledParagraphText, {
    color: "var(--color-global-black)",
    type: "paragraph",
    size: {
      xxs: 'm1',
      m: 'm1',
      l: '1'
    }
  }, paragraphText), (representativeText || buttonSlot) && /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledRepresentativeCTAWrapper, null, representativeText && /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledRepresentativeText, {
    color: "var(--color-global-black)",
    type: "heading",
    size: {
      xxs: 'm1'
    }
  }, representativeText), buttonSlot && /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledButtonSlot, null, buttonSlot)), linkText && linkUrl && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledLineBreak, null), /*#__PURE__*/_react["default"].createElement(_styledMarketingCard.StyledLink, {
    href: linkUrl,
    size: {
      xxs: 'small',
      xl: 'medium'
    },
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    underline: true,
    onClick: onClick,
    target: newWindow ? '_blank' : '_self' // open in new window if newWindow is true
    ,

    rel: newWindow ? 'noopener noreferrer' : '' // prevent security vulnerabilities if newWindow is true
  }, linkText))));
}
MarketingCardComponent.propTypes = propTypes;
MarketingCardComponent.defaultProps = defaultProps;